/**
 * Product-card thumbnail controller.
 * Uses event delegation so it also works for cards inserted later by
 * Shopify product recommendations, section rendering, pagination, etc.
 */
(function () {
  const THUMB_SELECTOR = '.product-card__thumb[data-media-id]';

  function getCard(target) {
    return target.closest('product-card');
  }

  function getInnerSlideshow(card) {
    return card?.querySelector('.card-gallery slideshow-component[ref="slideshow"]') ||
      card?.querySelector('.card-gallery slideshow-component');
  }

  function getSlides(slideshow) {
    const scroller = slideshow?.querySelector(':scope > slideshow-container > slideshow-slides') ||
      slideshow?.querySelector('slideshow-slides');
    if (!scroller) return [];
    return Array.from(scroller.children).filter((node) => node.tagName === 'SLIDESHOW-SLIDE');
  }

  function setActiveThumb(card, mediaId) {
    if (!card) return;
    const id = String(mediaId ?? '');
    card.querySelectorAll(THUMB_SELECTOR).forEach((thumb) => {
      const active = String(thumb.dataset.mediaId || '') === id;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function forceSelectDisabledSlideshow(slideshow, mediaId) {
    const slides = getSlides(slideshow);
    if (!slides.length) return false;

    const id = String(mediaId);
    const target = slides.find((slide) => String(slide.getAttribute('slide-id')) === id);
    if (!target) return false;

    // Keep the original thumbnail behavior for product-card galleries whose
    // slideshow is deliberately disabled (e.g. cards inside another carousel).
    slides.forEach((slide) => {
      const selected = slide === target;
      slide.removeAttribute('reveal');
      slide.hidden = !selected;
      slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
    });

    const scroller = target.parentElement;
    if (scroller instanceof HTMLElement) scroller.scrollLeft = 0;
    return true;
  }

  function selectThumbnail(button, event) {
    const card = getCard(button);
    if (!card) return;

    const mediaId = button.dataset.mediaId;
    if (!mediaId) return;

    const slideshow = getInnerSlideshow(card);
    if (!slideshow) return;

    const isDisabled = slideshow.getAttribute('disabled') === 'true' ||
      (slideshow.hasAttribute('mobile-disabled') && window.matchMedia('(max-width: 749px)').matches);

    if (!isDisabled && typeof slideshow.select === 'function') {
      slideshow.select({ id: mediaId }, event, { animate: false });
      setActiveThumb(card, mediaId);
      return;
    }

    if (forceSelectDisabledSlideshow(slideshow, mediaId)) {
      setActiveThumb(card, mediaId);
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(THUMB_SELECTOR);
    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();
    event.stopPropagation();
    selectThumbnail(button, event);
  });

  // Keep the active thumbnail synchronized when another theme control or a
  // variant change selects the slideshow media.
  document.addEventListener('slideshow:select', (event) => {
    if (!(event.target instanceof Element)) return;
    const card = event.target.closest('product-card');
    if (!card) return;

    const id = event.detail?.id;
    if (id != null) setActiveThumb(card, id);
  });
})();
